import 'timeago'

import $ from 'jquery'
import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import moment from 'moment'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziJotForm from 'data/jotform'
import PoziFragments from 'drawer/tabs/info/fragment/fragments'

function PoziJotFormComments () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziJotFormLikes().load Load JotForm Likes
     * @apiDescription Load JotForm likes and render on the info tab.
     * @apiGroup Fragments
     * @apiName JotFormLikes
     *
     * @apiParam {Object} fragmentOptions Fragment and Layer
     * @apiParam {Object} fragmentOptions.fragment Fragment
     * @apiParam {Object} fragmentOptions.fragment.id Fragment ID
     * @apiParam {Object} fragmentOptions.layer Layer
     *
     * @apiSuccess {Promise} Resolve No errors
     * @apiError {Promise} Reject Error to console
     */
    load: function (fragmentOptions) {
      return load(fragmentOptions)
    }
  }

  var load = function (fragmentOptions) {
    return check(fragmentOptions)
      .then(getData)
      .then(render)
      .then(success)
      .catch(error)
  }

  var getData = function (fragmentOptions) {
    return new Promise(function (resolve, reject) {
      const fragment = fragmentOptions.fragment
      fragment.url = fragment.url.replace('[timestampToNearestOneMin]', PoziUtils.timestampRoundedUpToMinutes(2))

      const bUseText = false // Uses label instead as property
      PoziJotForm()
        .getGeoJSON(fragment.url, bUseText)
        .then(function (geoJSON) {
          fragment.geoJSON = geoJSON
          resolve(fragmentOptions)
        })
        .catch(reject)
    })
  }

  var render = function (fragmentOptions) {
    return new Promise(function (resolve, reject) {
      const comments = []
      let err = ''
      console.log('Render JotForm likes', fragmentOptions)

      let commentCount = 0
      const jotFormDateOffsetHours = Model.get('config.settings.jotFormDateOffsetHours', 16) // This is set in templates.json
      const fragment = fragmentOptions.fragment
      const wrapper = PoziFragments().getWrapper(fragment)

      const featureidSelected = get(fragmentOptions, 'loadOptions.featureid', null)
      if (isNil(featureidSelected)) {
        err = 'Unable to find a featureid to compare.'
        return reject(err)
      }
      const geoJSON = get(fragment, 'geoJSON', null)
      if (isNil(geoJSON)) {
        err = 'Unable to render geojson'
        return reject(err)
      }
      const features = get(geoJSON, 'features', [])
      for (const key in features) {
        const feature = features[key]
        const featureidComment = get(feature, 'properties.featureId', null)
        if (isNil(featureidComment)) {
          continue
        }

        const comment = {}
        comment.text = get(feature, 'properties.comment', '')
        if (comment.text === '') {
          continue
        }

        comment.createdAt = get(feature, 'properties.created_at', '')
        // var mapLink = get(feature, 'properties.mapLink', '')

        if (featureidSelected === featureidComment) {
          comment.id = 'jotformcomments-' + fragment.id + '-' + featureidComment + '-' + commentCount
          try {
            const m = moment(comment.createdAt)
            // Annoyingly the date is the server time of the jotform server without any timezone info. (E.g. "2018-03-19 00:01:57")
            const d = m.add(jotFormDateOffsetHours, 'hours').toDate()
            comment.timeago = $.timeago(d)
          } catch (e) {
            console.log(e)
          }

          if (commentCount === 0) {
            const htmlHeader = $('<div>')
              .addClass('mdl-typography--headline')
              .addClass('jotform-comment-header-' + fragment.id)
              .append('Comments')
            wrapper.append(htmlHeader)
          }
          commentCount++
          const html = $('<div>')
            .attr('id', comments.id)
            .append('<b>' + comments.timeago + '</b>')
            .append('<br/>' + comments.text)
          // .append('<br/><a href="' + mapLink + '">Map Link</a>')

          wrapper.append('<hr/>')
          wrapper.append(html)

          comments.push(comment)
        }
      }

      fragmentOptions.comments = comments
      return resolve(fragmentOptions)
    })
  }

  var check = function (fragmentOptions) {
    return new Promise(function (resolve, reject) {
      let err = ''

      if (isNil(fragmentOptions)) {
        err = 'Invalid fragmentOptions object.'
        return reject(err)
      }

      if (!has(fragmentOptions, 'loadOptions')) {
        err = 'No loadOptions object.'
        return reject(err)
      }

      if (!has(fragmentOptions, 'fragment')) {
        err = 'No fragment object.'
        return reject(err)
      }

      const loadOptions = fragmentOptions.loadOptions

      if (isNil(loadOptions)) {
        err = 'Invalid loadOptions object.'
        return reject(err)
      }

      if (!has(loadOptions, 'layer')) {
        err = 'Must include loadOptions.layer.'
        return reject(err)
      }

      if (!has(loadOptions, 'titleid')) {
        err = 'Must include loadOptions.titleid.'
        return reject(err)
      }

      if (!has(loadOptions, 'featureid')) {
        err = 'Warning: does not include a loadOptions.featureid.'
        console.log(err)
      }

      const fragment = fragmentOptions.fragment

      if (get(fragment, 'url', '') === '') {
        err = 'No fragment URL found.'
        return reject(err)
      }

      return resolve(fragmentOptions)
    })
  }

  var success = function (fragmentOptions) {
    console.log('PoziJotFormComments load success.', fragmentOptions)
    return fragmentOptions
  }

  var error = function (err) {
    console.log('PoziJotFormComments load failed.', err)
    throw err
  }

  // Return adapters (must be at end of adapter)
  return adapters
}

export default PoziJotFormComments
// End A (Adapter)
